__turbopack_context__.v({
  "avatar": "WUserAccount-module__czZvDq__avatar",
  "avatarInitials": "WUserAccount-module__czZvDq__avatarInitials",
  "dropdown": "WUserAccount-module__czZvDq__dropdown",
  "dropdownEmail": "WUserAccount-module__czZvDq__dropdownEmail",
  "dropdownGreeting": "WUserAccount-module__czZvDq__dropdownGreeting",
  "dropdownHeader": "WUserAccount-module__czZvDq__dropdownHeader",
  "dropdownItem": "WUserAccount-module__czZvDq__dropdownItem",
  "errorState": "WUserAccount-module__czZvDq__errorState",
  "fadeIn": "WUserAccount-module__czZvDq__fadeIn",
  "formLinks": "WUserAccount-module__czZvDq__formLinks",
  "loginForm": "WUserAccount-module__czZvDq__loginForm",
  "loginIcon": "WUserAccount-module__czZvDq__loginIcon",
  "modal": "WUserAccount-module__czZvDq__modal",
  "modalBody": "WUserAccount-module__czZvDq__modalBody",
  "modalClose": "WUserAccount-module__czZvDq__modalClose",
  "modalHeader": "WUserAccount-module__czZvDq__modalHeader",
  "modalTitle": "WUserAccount-module__czZvDq__modalTitle",
  "overlay": "WUserAccount-module__czZvDq__overlay",
  "root": "WUserAccount-module__czZvDq__root",
  "slideInRight": "WUserAccount-module__czZvDq__slideInRight",
  "trigger": "WUserAccount-module__czZvDq__trigger",
  "triggerLabel": "WUserAccount-module__czZvDq__triggerLabel",
});
